import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';

function BasicDetails({
  formData,
  isEditing,
  errorField,
  isTransporterInvalid,
  isVehicleFormFieldEmpty,
  businessPartnerDataOption,
  transporterValue,
  transporterSearchTerm,
  setTransporterSearchTerm,
  setFormData,
  handleOnChange,
  handleVehicleChange,
  setVehicleSearchTerm,
  fetchVehicleDropdownOptions,
  vehicleNumberDataOption,
  vehicleValue,
  plantDataOption,
  workflowDataOption,
  plantLabel,
  workflowLabel,
}) {
  return (
    <div className="vehicle-tracking-detail-height vertical-padding-10 horizontal-padding-10">
      <span className="text-lg text-semi-bold">Basic Details</span>
      <Row>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Transporter Name
                  <span className="text-red">&nbsp;*</span>
                </span>
              </div>
              <div className="input-wrapper">
                <CustomMultiSelect
                  name="transporterId"
                  isMulti={false}
                  className={`margin-top-5 ${errorField && isTransporterInvalid ? 'react-select-input-error' : 'multi-select-input-section'}`}
                  onChange={(selectedOption) => {
                    const newTransporterId = selectedOption?.isCreateOption
                      ? null
                      : selectedOption?.value || null;
                    const newTransporterName = selectedOption?.isCreateOption
                      ? transporterSearchTerm
                      : selectedOption?.label || null;

                    setTransporterSearchTerm('');
                    if (!isVehicleFormFieldEmpty) {
                      setFormData((prev) => ({
                        ...prev,
                        transporterId: newTransporterId,
                        transporterName: newTransporterName,
                      }));
                      return;
                    }

                    handleOnChange({
                      target: {
                        name: 'transporterId',
                        value: newTransporterId,
                        transporterName: newTransporterName,
                        isCreateOption: selectedOption?.isCreateOption,
                      },
                    });
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === 'input-change') {
                      setTransporterSearchTerm(inputValue);
                    }
                  }}
                  options={businessPartnerDataOption}
                  classNamePrefix="react-select"
                  placeholder="Search Transporter Name"
                  value={transporterValue}
                  onBlur={() => setTransporterSearchTerm('')}
                />
                {!formData?.transporterName && (
                  <span className="form-input-section-icon">
                    <Search className="icon-size-sm" color="#9F9F9F" />
                  </span>
                )}
              </div>
              {errorField && isTransporterInvalid && (
                <span className="text-sm text-red">This field is required</span>
              )}
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Transporter Name
                  <span className="text-red">&nbsp;*</span>
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.transporterName || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Vehicle Number
                  <span className="text-red">&nbsp;*</span>
                </span>
              </div>
              <div className="input-wrapper">
                <CustomMultiSelect
                  name="vehicleId"
                  isMulti={false}
                  className={`margin-top-5 ${errorField && isVehicleFormFieldEmpty ? 'react-select-input-error' : 'multi-select-input-section'}`}
                  onChange={handleVehicleChange}
                  onInputChange={(inputValue, { action }) => {
                    if (action === 'input-change') {
                      setVehicleSearchTerm(inputValue.toUpperCase());
                    }
                  }}
                  onMenuOpen={fetchVehicleDropdownOptions}
                  options={vehicleNumberDataOption}
                  classNamePrefix="react-select"
                  placeholder="Search Vehicle Number"
                  value={vehicleValue}
                  onBlur={() => setVehicleSearchTerm('')}
                />
                {!formData?.vehicleNumber && (
                  <span className="form-input-section-icon">
                    <Search className="icon-size-sm" color="#9F9F9F" />
                  </span>
                )}
              </div>
              {errorField && isVehicleFormFieldEmpty && (
                <span className="text-sm text-red">This field is required</span>
              )}
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Vehicle Number
                  <span className="text-red">&nbsp;*</span>
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.vehicleNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Plant</span>
              </div>
              <div className="input-wrapper">
                <CustomMultiSelect
                  name="plant"
                  isMulti={false}
                  className="multi-select-input-section margin-top-5"
                  onChange={(selectedOption) => {
                    handleOnChange({
                      target: {
                        name: 'plant',
                        value: selectedOption?.value || null,
                      },
                    });
                  }}
                  options={plantDataOption}
                  classNamePrefix="react-select"
                  placeholder="Search Plant"
                  value={
                    plantDataOption.find(
                      (option) => option.value === formData?.plant,
                    ) || ''
                  }
                />
                <span className="form-input-section-icon">
                  <Search className="icon-size-sm" color="#9F9F9F" />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Plant</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {plantLabel || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Workflow</span>
              </div>
              <div className="input-wrapper">
                <CustomMultiSelect
                  name="workflowId"
                  isMulti={false}
                  className="margin-top-5 multi-select-input-section"
                  onChange={(selectedOption) => {
                    handleOnChange({
                      target: {
                        name: 'workflowId',
                        value: selectedOption?.value || null,
                        label: selectedOption?.label || null,
                      },
                    });
                  }}
                  options={workflowDataOption}
                  classNamePrefix="react-select"
                  placeholder="Select Workflow"
                  value={workflowDataOption.find(
                    (option) => option.value === formData?.workflowId,
                  )}
                />
                <span className="form-input-section-icon">
                  <Search className="icon-size-sm" color="#9F9F9F" />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Workflow</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {workflowLabel || '-'}
              </span>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default BasicDetails;
